import {BrickContext, Brick, registerBrick } from 'olympe';
import LoadSTTModel from "./LoadSTTModel";
import {getLogger} from "@olympeio/core";

export default class DoModelExist extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(boolean)} setExists
     */
    update($, [model], [setExists]) {
        // check if the data is already in the IndexedDB
        const openConnection = indexedDB.open(LoadSTTModel.dbName, LoadSTTModel.dbVersion);

        openConnection.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (db.version === 1) {
                db.createObjectStore('models', { autoIncrement: false });
                getLogger('LocalOpenAI').info('loadRemote: created IndexedDB ' + db.name + ' version ' + db.version);
            } else {
                // clear the database
                const os = event.currentTarget.transaction.objectStore('models');
                os.clear();
                getLogger('LocalOpenAI').info('loadRemote: cleared IndexedDB ' + db.name + ' version ' + db.version);
            }
        };

        openConnection.onsuccess = (event) => {
            try {
                const db = event.target.result;
                const tx = db.transaction(['models'], 'readonly');
                const os = tx.objectStore('models');
                const rq = os.get(LoadSTTModel.urls[model]);

                rq.onsuccess = () => {
                    if (rq.result) {
                        setExists(true);
                    } else {
                        setExists(false);
                    }
                };

                rq.onerror = () => {
                    getLogger('LocalOpenAI').error('an error occurred while trying to execute the request on the indexed db');
                    setExists(false);
                };
            } catch (e) {
                setExists(false);
            }
        };

        openConnection.onerror = function () {
            getLogger('LocalOpenAI').error('an error occurred while trying to open the indexed db');
            setExists(false);
        };

        openConnection.onblocked = function () {
            getLogger('LocalOpenAI').error('a blocking occurred while trying to open the indexed db');
            setExists(false);
        };

        openConnection.onabort = function () {
            getLogger('LocalOpenAI').error('an abortion signal occurred while trying to open the indexed db');
            setExists(false);
        };
    }
}

registerBrick('0190e4d1691783bf62d6', DoModelExist);
